<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
  >
    <template #header>
      {{ modalTitle }}
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i>
    </template>

    <ReportsView
      :fromUserHasReports="idUser"
      :fromUserGroupHasReports="idGrupo"
    />
  </Dialog>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import Dialog from "primevue/dialog";

import ReportsView from "@/pages/_root/reports/ReportsView.vue";

// #region Props, Emits
const props = defineProps({
  fromUserHasReports: {
    type: Boolean,
    default: false,
  },
  fromUserGroupHasReports: {
    type: Boolean,
    default: false,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const showModalRef = ref(false);
const idUser = ref(null);
const idGrupo = ref(null);

const modalTitle = computed(() => {
  if (props.fromUserHasReports) {
    return "Informes del usuario";
  } else if (props.fromUserGroupHasReports) {
    return "Informes del grupo de usuarios";
  }

  return "Informes";
});
// #endregion

// #region Functions
// Open the modal with the data
function showModal(data) {
  idUser.value = data.idUser;
  idGrupo.value = data.idGrupo;

  // Show the modal
  showModalRef.value = true;
}

function closeModal() {
  showModalRef.value = false;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>
